export const getArrayOfUniqueObjectsByKey = <T>(
  items: T[],
  key: keyof T,
): T[] => [...new Map(items.map((item) => [item[key], item])).values()];
